import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NetworkService } from '../../network/network.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService implements HttpInterceptor {
  constructor(
    private networkService: NetworkService
  ) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      /**
       * Ad ogni richiesta, mi metto in ascolto del suo esito
       * e scateno degli effetti collaterali per registrare 
       */
      tap(
        event => {
          if (event instanceof HttpResponse) {
            this.networkService.setOnline();
          } else {
            // Non e' una risposta ma una richiesta
          }
        },
        error => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 0) {
              console.warn('Offline');
              this.networkService.setOffline();
            } else if (((error.status / 100) === 4) || ((error.status / 100) === 5)) {
              console.warn('Errore interno al server o bad request', error);
              this.networkService.setLastRequestFailure();
            }
          }
        }
      )
    );
  }
}
